import Service from "../../../Services/index";

const ProductType = {
    namespaced: true,
    state: {
        table: [],
        replace_data : []
    },
    mutations: {
        GET_MATERIAL_INSPECTION: (state, res) => {
            state.table = res;
        },
        GET_REPLACE_DATA: (state, res) => {
            state.replace_data = res;
        },
    },
    actions: {
        get({ commit }) {
            return Service.MaterialInspect.getMaterialInspect().then(response => {
                commit("GET_MATERIAL_INSPECTION", response);
            });
        },
        update({commit},{id,data}){
            return Service.MaterialInspect.updateMaterialInspect(id,data).then(response=>{
            })
        },
        show({commit},id){
            return Service.MaterialInspect.showMaterialInspect(id).then(response=>{
                commit("GET_REPLACE_DATA",response)
            })
        },
        clear({commit},shift_id){
            return Service.MaterialInspect.clearInspect(shift_id);
        },
        search({commit},code){
            return Service.MaterialInspect.searchMaterialInspect(code)
                .then(data=>{
                    commit("GET_MATERIAL_INSPECTION",data)
                })
        }
    }
};

export default ProductType;
